import db from '../db';

const categories = db.table('categories');

async function getAllCategories() {
  try {
    return await categories.toArray();
  } catch (error) {
    throw error;
  }
}

async function getOneCategory(id) {
  try {
    let local_exec = await categories.get({id: Number(id)});
    return local_exec 
  } catch (error) {
    throw error
  }
}

async function createCategory(category) {
  try {
    return await categories.add({...category});
  } catch (error) {
    throw error;
  }
}

async function createBulkCategories(categories) {
  console.log({...categories})
  try {
    await db.categories.bulkPut(categories)
  } catch (error) {
    throw error;
  }
}

async function updateOneCategory(category) {
  try {
    await categories.put({...category});
    return category;
  } catch (error) {
    throw error
  }
};

export default {
  getAllCategories,
  getOneCategory,
  updateOneCategory,
  createCategory,
  createBulkCategories
};